import React, { Component } from 'react';
import { Grid, TextField, Button, Typography } from '@material-ui/core';
// import Tooltip from '@material-ui/core/Tooltip';
// import InfoIcon from '@material-ui/icons/InfoOutlined';
// import {validId} from '../services/CalcService';
import {Settings} from '@material-ui/icons';
import * as GServ from '../services/GatewayService';

export default class RegisterMe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name_input : '',
            id_input: '',
            empl_num_input: '',
            // input_label : 'Document Tag',
            name_error: false,
            id_error: false,
            empl_num_error: false,
            can_submit: false,
            registering: false,
            error: false,
            error_message: ''
        }
    }
    
    componentDidMount = () => {
      this.setState({
          input_text : this.props.tag? this.props.tag : '',
          said_switch : this.props.tag_type? this.props.tag_type==="said"? true : false  : true  
      })
    };    

    
    render() {
        return (
            <Grid 
                container 
                direction='column'
                justifyContent='space-around'
                alignItems='center'
                style={{
                    // backgroundColor:'green',
                }}
            >
                <Typography
                    color='primary'
                >
                    Please confirm a few details so we can activate your registration...
                </Typography>
                <br/>

                <form onSubmit={this.submitHandler}>
                <Grid 
                    container
                    direction='column'
                    alignItems='center'
                    // style={{backgroundColor:'palegreen'}}
                >
                    <TextField
                        // color='primary'
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="on"
                        autoFocus={true}
                        inputProps={{maxLength: 25 }}
                        error={this.state.name_error}
                        // id="filled-error-helper-text"
                        label={'Your Surname'}
                        // helperText={'Please enter your surname'}
                        variant='outlined'
                        // placeholder={this.state.said_switch ? 'South African ID Number' : 'E.g. Foreign Passport No.'}
                        value={this.state.name_input}
                        onChange={(e) => {
                            const outText = e.target.value.replace(/[^ A-Za-z]+/g, '').toUpperCase();
                            const can_sub = (outText.length>=3 && this.state.id_input && this.state.empl_num_input)
                            this.setState({name_input: outText, can_submit: can_sub, error: false});
                        }}
                        required
                        style={{marginBottom:'10px', width:'225px'}}
                        
                        disabled={this.state.registering}
                        
                        // inputRef={(element) => {this.textInput=element}}
                    />

                    <TextField
                        // color='primary'
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="on"
                        autoFocus={false}
                        inputProps={{maxLength: 13 }}
                        error={this.state.id_error}
                        // id="filled-error-helper-text"
                        label={'Your ID/Passport Number'}
                        // helperText={'Please enter your surname'}
                        variant='outlined'
                        // placeholder={this.state.said_switch ? 'South African ID Number' : 'E.g. Foreign Passport No.'}
                        value={this.state.id_input}
                        onChange={(e) => {
                            const outText = e.target.value.replace(/[^0-9A-Za-z]+/g, '').toUpperCase();   
                            const can_sub = (this.state.name_input.length >=3 && outText.length>0 && this.state.empl_num_input)
                            this.setState({id_input: outText, id_error: false, can_submit: can_sub});
                        }}
                        required
                        style={{marginBottom:'10px', width:'225px'}}
                        disabled={this.state.registering}
                        // inputRef={(element) => {this.textInput=element}}
                    />
                    <TextField
                        // color='primary'
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="on"
                        autoFocus={false}
                        inputProps={{maxLength: 10 }}
                        error={this.state.empl_num_error}
                        // id="filled-error-helper-text"
                        label={'Your Employee Number'}
                        // helperText={'Please enter your surname'}
                        variant='outlined'
                        // placeholder={this.state.said_switch ? 'South African ID Number' : 'E.g. Foreign Passport No.'}
                        value={this.state.empl_num_input}
                        onChange={(e) => {
                            const outText = e.target.value.replace(/[^0-9a-zA-Z]+/g, '').toUpperCase();   
                            const can_sub = (this.state.name_input.length >=3 && this.state.id_input && outText.length>0)
                            this.setState({empl_num_input: outText, empl_num_error: false, can_submit:can_sub});
                        }}
                        required
                        disabled={this.state.registering}
                        style={{width:'225px'}}
                        // inputRef={(element) => {this.textInput=element}}
                    />

                </Grid>
                
                <Grid 
                    item
                    // direction='row'
                    style={{
                        marginTop:10,
                        marginLeft:30
                    }} 
                    
                >
                    <Grid 
                        container
                        direction='row'
                        alignItems='center'
                    >
                    {/* <Switch 
                        checked={this.state.said_switch}
                        onChange={(e) => {
                            this.setState({said_switch: e.target.checked,input_text:'', error: false, helper_text:'' });
                            this.textInput.focus();
                        }}
                        color='primary'
                    /> */}

                    </Grid>

                </Grid>
                <br/>    

                <Grid 
                    container
                    // style={{backgroundColor:'orangered'}}
                    justifyContent='center'
                >
                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        disabled={!this.state.can_submit}
                    >
                        Activate Registration
                    </Button>
                </Grid>
                </form>

                {this.state.registering&&
                <div style={{display:'block', width:'50%'}}>
                    <br/>
                    {!this.state.error&&
                    <span><Settings className='icn-spinner' /> Activating...</span>}
                    {this.state.error&&
                    <Typography color='secondary'>{this.state.error_message}</Typography>}                 
                </div>}

            </Grid>
        );
    }

    submitHandler = (e) => {
        e.preventDefault();
        // console.log('e :>> ', e);
        this.setState({can_submit:false, registering:true});
        GServ.registerMe(this.props.gwt,{
            surname: this.state.name_input,
            id_num: this.state.id_input,
            empl_num: this.state.empl_num_input
        })
        .then(async reply => {
            // console.log('reply from GServ.registerMe :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv.registerme :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to activate your registration at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&(reply.Message.includes('no match'))){
                this.setState({error:true,error_message:"Unfortunately these details don't match a current employment record. You're welcome to refresh this page and resubmit if they've been entered incorrectly. If the details you've entered are correct however and this message persists, please contact us."});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv.registerme :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to activate your registration at the moment. If this problem persists, please contact us."});
            } else {
                //Run LDP cron update sync...
                await GServ.runCron(this.props.gwt)
                .then(cron_reply => {
                    if (cron_reply.Result !== "Success"){
                        console.log('cron_reply :>> ', cron_reply);
                    }
                });

                //Fresh sign in if this is a TMS use case registration, else just update props...
                if (this.props.is_lms_login){
                    this.props.setParentState({just_registered:true, registered: true, gwt: reply.Gwt, admin: reply.Admin, rom: reply.ROM});
                } else {
                    window.location.reload(true);
                }

            }
        });

    }

}